"use strict";

exports.__esModule = true;
var _DeviceContext = require("./DeviceContext");
Object.keys(_DeviceContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceContext[key]) return;
  exports[key] = _DeviceContext[key];
});